module.exports = __webpack_public_path__ + "static/img/8.066aab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/电商新零售/8.png
// module id = OW7V
// module chunks = 1